import React, { useState, useContext } from 'react';
import { Form, Input, InputGroup, UncontrolledPopover, PopoverHeader, PopoverBody, Button } from 'reactstrap';
import { ThemedButton } from './themed-button';
import { useTranslate } from 'react-translate';
import { ThemeContext, defaultTheme } from '../theme';

export function LoginForm(props) {
    const theme = useContext(ThemeContext) || defaultTheme;
    const t = useTranslate('Login');
    const [userName, setUserName] = useState(props.userName ?? '');
    const [userEmail, setUserEmail] = useState(props.userEmail ?? '');

    const EMAIL_REGEX = /^([\w._%+-]+)@([\w.-]+)\.([a-zA-Z]{2,})$/

    var pathName = window.location.pathname.trim().replaceAll('/', '');
    const handleEmail = pathName.endsWith('e') || pathName.endsWith('E');
    const isValid = userName && userName.length > 2 &&
        (handleEmail ? (userEmail && userEmail.length > 2 && EMAIL_REGEX.test(userEmail)) : true);
    const themedStyle =
    {
        backgroundColor: theme.darkColor,
        borderColor: theme.darkColor,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        padding: '0 5px',
        fontSize: '22px'
    };

    function join(event) {
        event.preventDefault();
        if (isValid) {
            props.joinSessionAsync(userName, userEmail);
        }
    }

    return (
        <Form className="inlineInput">
            <Input type="text"
                value={userName}
                onChange={e => setUserName(e.target.value)}
                placeholder={t('name.full')}
                aria-label={t('name.short')}
                id="username"
                name="name"
                autoComplete="name"
                className="input-field" />
            {handleEmail ? (<InputGroup>
                <Input type="email"
                    value={userEmail}
                    onChange={e => setUserEmail(e.target.value)}
                    placeholder={t('email.full')}
                    aria-label={t('email.short')}
                    id="useremail"
                    name="email"
                    autoComplete="email"
                    className="input-field" />
                <Button
                    id="Popover1"
                    type="button"
                    style={themedStyle}>
                    <i className="las la-info-circle"></i>
                </Button>
                <UncontrolledPopover
                    target="Popover1"
                    placement="top"
                    trigger="focus">
                    <PopoverHeader className="popover-header">
                        {t('email.title')}
                    </PopoverHeader>
                    <PopoverBody>
                        {t('email.details')}
                    </PopoverBody>
                </UncontrolledPopover>
            </InputGroup>) : ""}
            <ThemedButton type="submit" content={t('join')} onClick={join} disabled={!isValid} />
        </Form>);
}